
export class UnitLineDateRequest {
    unit: string;
    date: string;
    clientId: number;
    lineId?: string;

    fromTime?: string; // HH-MM-SS
    toTime?: string; // HH:MM::SS
    isGroupByHour?: boolean;
}